import {RouterModule, UrlMatchResult, UrlMatcher, UrlSegment} from '@angular/router';
import {NgModule} from '@angular/core';
import {AppMainComponent} from './app.main.component';
import {AppNotfoundComponent} from './pages/app.notfound.component';
import { DocumentSignComponent } from './modules/document-sign/views/default/document-sign.component';

const documentSignMatcher: UrlMatcher = (segments: UrlSegment[]): UrlMatchResult | null => {
    if (!segments.length || segments[0].path !== 'document-sign') {
        return null;
    }

    // accepted forms:
    // document-sign/:document
    // document-sign/:document/:fallback
    // document-sign/:document/:fallback/:locale
    // document-sign/:document/:fallback/:locale/:type
    if (segments.length < 2 || segments.length > 5) {
        return null;
    }

    const posParams: {[key: string]: UrlSegment} = {
        document: segments[1]
    };

    if (segments.length >= 3) {
        posParams.fallback = segments[2];
    }
    if (segments.length >= 4) {
        posParams.locale = segments[3];
    }
    if (segments.length >= 5) {
        posParams.type = segments[4];
    }

    return {
        consumed: segments,
        posParams
    };
};
@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '', data: {reuse: false}, component: AppMainComponent,
                children: [
                    {matcher: documentSignMatcher, data: {reuse: false}, component: DocumentSignComponent}
                ]
            },
            {path: 'notfound', component: AppNotfoundComponent},
            {path: '**', redirectTo: '/notfound'},
        ], {scrollPositionRestoration: 'enabled'})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
